<template>
  <div style="margin-top: 2rem">
    <div>
      <a
        ref="umgSubDownload"
        :href="umgSubHrefData"
        download="sub_report.txt"
        target="_blank"
        >Download Sub Details Report</a
      >
    </div>
    <div>
      <a
        ref="umgTopDownload"
        :href="umgTopHrefData"
        download="topsheet_report.txt"
        target="_blank"
        >Download Topsheet Report</a
      >
    </div>

    <div class="d-flex">
      <h5>
        <b-badge class="mr-4" :variant="isPublished ? 'primary' : 'danger'">
          <span>{{ isPublished ? "Published" : "Unpublished" }}</span>
        </b-badge>
      </h5>
      <h5
        v-for="(share, tier) in $store.state.finance.totalLengthShares"
        :key="tier"
        class="ml-4"
      >
        <span>{{ $helpers.prettify(tier) }}: </span>
        <b-badge>{{ $helpers.percentageFormatter(share) }}%</b-badge>
      </h5>
    </div>

    <!-- <b-row class="mr-0 mt-4"> -->
    <!-- <b-col> -->
    <!-- <h5 style="margin-bottom: 2rem; height: 2rem;">Partners</h5> -->

    <!-- <b-table class="mt-3" :items="providerItems" :fields="providerFields" ref="table" striped> -->
    <!-- </b-table> -->

    <!-- </b-col> -->
    <!-- <b-col> -->
    <!-- </b-col> -->
    <!-- </b-row> -->

    <h5 style="margin-top: 4rem">Data</h5>
    <b-table
      class="mt-3"
      :items="contentItems"
      :fields="contentFields"
      ref="table"
      @row-clicked="handleSelectedRow"
      striped
      hover
      small
      :per-page="perPage"
      :current-page="currentPage"
    />

    <div v-if="perPage" class="d-flex justify-content-center">
      <b-pagination
        :total-rows="contentItems.length"
        :per-page="perPage"
        v-model="currentPage"
      />
    </div>

    <RevShareContentDetailsModal ref="contentDetailsModal" />
  </div>
</template>

<script>
import RevShareContentDetailsModal from "./RevShareContentDetailsModal.vue";

export default {
  name: "RevShareUmgContentOverview",

  components: {
    RevShareContentDetailsModal,
  },

  data: function () {
    let providerFields = [];

    if (this.$config.enableAds) {
      providerFields = [
        { key: "provider", label: "Partner", sortable: true },
        {
          key: "points.premium",
          label: "Premium Points",
          sortable: true,
          formatter: this.$helpers.premiumPointsFormatter,
          tdClass: "text-right",
        },
        {
          key: "points.ad_supported",
          label: "Ad Supported Points",
          sortable: true,
          formatter: this.$helpers.premiumPointsFormatter,
          tdClass: "text-right",
        },
        {
          key: "billable_amount",
          label: "Billable Amount (€)",
          sortable: true,
          formatter: this.$helpers.fractionalCurrencyFormatter,
          tdClass: "text-right",
        },
        {
          key: "no_rev_share_amount",
          label: "TOA Amount (€)",
          sortable: true,
          formatter: this.$helpers.fractionalCurrencyFormatter,
          tdClass: "text-right",
        },
      ];
    } else {
      providerFields = [
        { key: "provider", label: "Partner", sortable: true },
        {
          key: "points.premium",
          label: "Points",
          sortable: true,
          formatter: this.$helpers.premiumPointsFormatter,
          tdClass: "text-right",
        },
        {
          key: "billable_amount",
          label: "Billable Amount (€)",
          sortable: true,
          formatter: this.$helpers.fractionalCurrencyFormatter,
          tdClass: "text-right",
        },
        {
          key: "no_rev_share_amount",
          label: "TOA Amount (€)",
          sortable: true,
          formatter: this.$helpers.fractionalCurrencyFormatter,
          tdClass: "text-right",
        },
      ];
    }

    return {
      providerFields: providerFields,

      contentFields: [
        { key: "title", label: "Title", sortable: true },
        { key: "series", label: "Series", sortable: true },
        { key: "season", label: "Season", sortable: true },
        { key: "upc", label: "UPC", sortable: true },
        {
          key: "isrc",
          label: "ISRC",
          formatter: this.$helpers.arrayFormatter,
          sortable: true,
        },
        { key: "reporting_code", label: "Reporting Code", sortable: true },
        { key: "provider", label: "Partner", sortable: true },
        {
          key: "media_type",
          label: "Type",
          sortable: true,
          formatter: this.$helpers.prettify,
        },
        {
          key: "no_rev_share",
          label: "TOA",
          formatter: this.$helpers.booleanFormatter,
          sortable: true,
        },
        {
          key: "tier",
          label: "Tier",
          sortable: true,
          formatter: this.$helpers.prettify,
        },
        {
          key: "total_count",
          label: "Views",
          sortable: true,
          tdClass: "text-right",
        },
        {
          key: "total_length",
          label: "Duration",
          sortable: true,
          formatter: this.$helpers.durationToString,
          tdClass: "text-right",
        },
        {
          key: "total_points",
          label: "Points",
          sortable: true,
          tdClass: "text-right",
          formatter: this.$helpers.premiumPointsFormatter,
        },
        {
          key: "total_cost",
          label: "Cost",
          sortable: true,
          tdClass: "text-right",
        },
        {
          key: "total_amount",
          label: "Amount (€)",
          sortable: true,
          formatter: this.$helpers.fractionalCurrencyFormatter,
          tdClass: "text-right",
        },
      ],

      umgSubExcel: null,
      umgTopExcel: null,

      currentPage: 1,
      perPage: 20,
    };
  },

  computed: {
    items() {
      return [];
    },

    umgSubHrefData() {
      return (
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        this.umgSubExcel
      );
    },

    umgTopHrefData() {
      return (
        "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
        this.umgTopExcel
      );
    },

    contentItems() {
      return this.$store.state.finance.data;
    },

    providerItems() {
      return this.$store.state.finance.providerItems;
    },

    isPublished() {
      return this.$store.state.finance.isPublished;
    },
  },

  watch: {
    contentItems(v) {
      this.buildExcelExport(v);
    },
  },

  methods: {
    handleSelectedRow(row) {
      let items = this.$_.values(row.geos);
      this.$refs.contentDetailsModal.show(row.media_id, row.title, items);
    },

    buildExcelExport(content) {
      return content;
    },
  },
};
</script>

<style scoped></style>
